import { render } from "./leaves-admin-modal.vue?vue&type=template&id=09af8380"
import script from "./leaves-admin-modal.vue?vue&type=script&lang=js"
export * from "./leaves-admin-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__